var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-plus"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg899104190_1273_filter0_d_1039_901)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    rx: 3,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    rx: 3,
    stroke: "url(#svg899104190_1273_paint0_linear_1039_901)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 18V13M16 13V8M16 13H21M16 13H11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg899104190_1273_filter0_d_1039_901",
    x: -9,
    y: -9,
    width: 57,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.301983 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1039_901"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1039_901",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg899104190_1273_paint0_linear_1039_901",
    x1: -5.13051,
    y1: 10.7809,
    x2: 8.73711,
    y2: 32.7444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202329"
  }))))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-minus"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-982020550_1250_filter0_d_1039_904)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    rx: 3,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    rx: 3,
    stroke: "url(#svg-982020550_1250_paint0_linear_1039_904)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21 13L11 13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg-982020550_1250_filter0_d_1039_904",
    x: -9,
    y: -9,
    width: 57,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.301983 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1039_904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1039_904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-982020550_1250_paint0_linear_1039_904",
    x1: -5.13051,
    y1: 10.7809,
    x2: 8.73711,
    y2: 32.7444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202329"
  }))))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-arrow-left"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg979240422_1852_filter0_d_1039_593)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    rx: 3,
    fill: "#191815"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    rx: 3,
    stroke: "url(#svg979240422_1852_paint0_linear_1039_593)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.6003 21.5875C19.727 21.4464 19.8275 21.2789 19.8961 21.0944C19.9647 20.9099 20 20.7121 20 20.5124C20 20.3127 19.9647 20.1149 19.8961 19.9305C19.8275 19.746 19.727 19.5784 19.6003 19.4373L14.2972 13.5205L19.6003 7.60359C19.8559 7.31846 19.9994 6.93173 19.9994 6.52849C19.9994 6.12525 19.8559 5.73852 19.6003 5.45339C19.3447 5.16825 18.9981 5.00807 18.6367 5.00807C18.2753 5.00807 17.9287 5.16825 17.6732 5.45339L11.3997 12.453C11.273 12.5941 11.1725 12.7616 11.1039 12.9461C11.0353 13.1306 11 13.3284 11 13.5281C11 13.7278 11.0353 13.9256 11.1039 14.11C11.1725 14.2945 11.273 14.4621 11.3997 14.6032L17.6732 21.6028C18.1925 22.1823 19.0673 22.1823 19.6003 21.5875Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg979240422_1852_filter0_d_1039_593",
    x: -8.5,
    y: -8.5,
    width: 56,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.301983 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1039_593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1039_593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg979240422_1852_paint0_linear_1039_593",
    x1: -5.13051,
    y1: 10.7809,
    x2: 8.73711,
    y2: 32.7444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202329"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg1921611244_1845_filter0_d_1039_590)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    rx: 3,
    fill: "#2D2C28"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    rx: 3,
    stroke: "url(#svg1921611244_1845_paint0_linear_1039_590)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.3997 5.45603C11.273 5.59711 11.1725 5.76469 11.1039 5.94917C11.0353 6.13365 11 6.33141 11 6.53113C11 6.73086 11.0353 6.92862 11.1039 7.1131C11.1725 7.29758 11.273 7.46515 11.3997 7.60623L16.7028 13.5231L11.3997 19.44C11.1441 19.7251 11.0006 20.1118 11.0006 20.5151C11.0006 20.9183 11.1441 21.305 11.3997 21.5902C11.6553 21.8753 12.0019 22.0355 12.3633 22.0355C12.7247 22.0355 13.0713 21.8753 13.3268 21.5902L19.6003 14.5906C19.727 14.4495 19.8275 14.2819 19.8961 14.0974C19.9647 13.913 20 13.7152 20 13.5155C20 13.3157 19.9647 13.118 19.8961 12.9335C19.8275 12.749 19.727 12.5815 19.6003 12.4404L13.3268 5.44078C12.8075 4.8613 11.9327 4.8613 11.3997 5.45603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg1921611244_1845_filter0_d_1039_590",
    x: -8.5,
    y: -8.5,
    width: 56,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.301983 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1039_590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1039_590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg1921611244_1845_paint0_linear_1039_590",
    x1: -5.13051,
    y1: 10.7809,
    x2: 8.73711,
    y2: 32.7444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202329"
  }))))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-arrow-back"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.292893 7.29289C-0.0976314 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34314C8.46159 1.95262 8.46159 1.31946 8.07107 0.928931C7.68054 0.538407 7.04738 0.538407 6.65686 0.928931L0.292893 7.29289ZM20 7L1 7L1 9L20 9L20 7Z",
    fill: "white"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.292444 0.293762C0.199741 0.386276 0.126193 0.496165 0.0760117 0.617138C0.0258302 0.738111 0 0.867794 0 0.998762C0 1.12973 0.0258302 1.25941 0.0760117 1.38039C0.126193 1.50136 0.199741 1.61125 0.292444 1.70376L4.17244 5.58376L0.292444 9.46376C0.105467 9.65074 0.000423431 9.90434 0.000423431 10.1688C0.000423431 10.4332 0.105467 10.6868 0.292444 10.8738C0.479422 11.0607 0.733018 11.1658 0.997444 11.1658C1.26187 11.1658 1.51547 11.0607 1.70244 10.8738L6.29244 6.28376C6.38515 6.19125 6.4587 6.08136 6.50888 5.96039C6.55906 5.83941 6.58489 5.70973 6.58489 5.57876C6.58489 5.44779 6.55906 5.31811 6.50888 5.19714C6.4587 5.07616 6.38515 4.96628 6.29244 4.87376L1.70244 0.283762C1.32244 -0.0962379 0.682444 -0.0962377 0.292444 0.293762Z",
    fill: "white"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-home"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.63,19.77v-3.06c0-.78.64-1.41,1.42-1.41h2.87c.38,0,.74.15,1.01.41.27.27.42.62.42,1v3.06c0,.32.13.64.36.87.23.23.54.36.87.36h1.96c.92,0,1.8-.36,2.44-1,.65-.64,1.01-1.51,1.01-2.42v-8.71c0-.73-.33-1.43-.9-1.9L12.43,1.68c-1.16-.93-2.82-.9-3.95.07L1.97,6.96c-.59.46-.95,1.16-.97,1.9v8.7c0,1.9,1.55,3.43,3.46,3.43h1.92c.68,0,1.23-.54,1.24-1.22h.03Z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    width: 64,
    height: 45,
    viewBox: "0 0 64 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-logo"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-781080315_8527_clip0_1039_586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8256 41.9664C9.8848 42.5088 0.0096 43.5027 0.0096 43.5027L0 43.428C0 43.428 9.824 41.9599 14.752 41.2714C14.9696 41.2454 15.024 41.9372 14.8256 41.9632V41.9664ZM63.9904 35.4543C63.9904 35.4543 54.1056 36.4417 49.1648 36.9841C48.9472 37.0101 49.0592 37.6987 49.2576 37.6727C54.1792 36.9874 64 35.529 64 35.529L63.9904 35.4543ZM24.192 37.5558C24.5504 37.5103 24.8 37.1757 24.752 36.7827C24.704 36.3897 24.3808 36.1137 24.0224 36.1591C23.664 36.2046 23.424 36.5521 23.472 36.9451C23.52 37.3381 23.8304 37.6045 24.192 37.559V37.5558ZM32.3488 36.5392C32.7072 36.4937 32.9568 36.1591 32.9088 35.7661C32.8608 35.3731 32.5376 35.0971 32.1792 35.1393C31.8208 35.1815 31.5808 35.5323 31.6288 35.9253C31.6768 36.3183 31.9872 36.5846 32.3488 36.5392ZM47.9136 38.9556C47.1424 40.2255 46.224 41.4208 45.3152 41.5345C44.7552 41.6059 44.3776 41.3233 44.2688 40.8654C43.7984 41.4045 43.2832 41.7878 42.8416 41.843C42.2112 41.921 41.8176 41.5475 41.7696 40.9856C41.2416 41.6351 40.6816 42.1126 40.1216 42.1808C39.232 42.2912 38.8064 41.5117 39.1616 40.5633L40.0576 38.2086C40.1536 37.9488 40.0736 37.7117 39.9104 37.533L39.7376 37.3544C39.0176 38.7705 38.6784 39.4233 38.2304 40.1606C37.4592 41.4305 36.5408 42.6258 35.632 42.7394C35.072 42.8109 34.6944 42.5283 34.5856 42.0704C34.1152 42.6095 33.6 42.9928 33.1584 43.048C32.528 43.1259 32.1344 42.7524 32.0864 42.1905C31.5584 42.8401 30.9984 43.3176 30.4384 43.389C29.808 43.467 29.4144 43.0935 29.3664 42.5316C28.8384 43.1812 28.2784 43.6586 27.7184 43.7301C27.088 43.808 26.6944 43.4345 26.6464 42.8726C26.1184 43.5222 25.5584 43.9996 24.9984 44.0678C24.368 44.1458 23.9744 43.7723 23.9264 43.2104C23.3984 43.86 22.8384 44.3374 22.2784 44.4056C21.4976 44.5031 21.072 43.9087 21.2256 43.1194C20.8224 43.3923 20.3872 43.5742 20.0448 43.6164C19.9616 43.6261 19.8848 43.6359 19.7984 43.6359C19.3408 44.4803 18.6752 44.9156 18.0608 44.9903C17.3504 45.0779 16.736 44.6849 16.6368 43.8632C16.592 43.4832 16.6528 43.0155 16.8672 42.4731L19.2672 36.2111L20.3872 36.0715L19.312 38.8939C19.5136 38.7055 19.7344 38.5724 20 38.5399C20.6144 38.4619 21.0496 38.8777 21.1232 39.4915C21.168 39.8748 21.088 40.3522 20.8768 40.9206L20.0768 43.0058C20.6144 42.9278 21.2064 42.5705 21.6288 41.908L21.6928 41.8073L23.0208 38.3288L24.1216 38.1923L22.3072 42.9863C22.1088 43.493 22.2688 43.6586 22.512 43.6294C22.9984 43.5677 23.6736 42.6745 24.3456 41.5702L24.4096 41.4695L26.7744 35.279L27.8752 35.1425L25.024 42.6485C24.8256 43.1552 24.9856 43.3208 25.2288 43.2916C25.7152 43.2299 26.3904 42.3367 27.0624 41.2324L27.1264 41.1317L29.4912 34.9412L30.592 34.8048L27.7408 42.3107C27.5424 42.8174 27.7056 42.983 27.9456 42.9538C28.432 42.8921 29.1072 41.9989 29.7792 40.8946L29.8432 40.7939L31.1712 37.3154L32.272 37.179L30.4576 41.9729C30.2592 42.4796 30.4224 42.6453 30.6624 42.616C31.1488 42.5543 31.824 41.6611 32.496 40.5568L32.56 40.4562L33.376 38.332C33.7344 37.3966 34.4992 36.7827 35.0912 36.708C35.8112 36.6171 36.3712 37.2634 36.3904 37.7799L37.0144 37.7019L35.648 41.3233C35.4528 41.83 35.6128 41.9957 35.856 41.9664C36.3424 41.9047 37.0176 41.0115 37.6896 39.9073L37.7536 39.8066C38.3616 38.79 38.8928 37.6922 39.2896 36.8802L39.1776 36.7535C38.72 36.2468 38.688 35.5583 39.2384 34.8665L39.8912 35.4771C39.696 35.7369 39.728 35.9805 39.9136 36.1786L40.624 36.9127C41.04 37.3414 41.2736 37.7474 40.9792 38.5236L40.1344 40.7647C39.9392 41.2714 40.0992 41.437 40.3424 41.4078C40.8288 41.3461 41.504 40.4529 42.176 39.3486L42.24 39.2479C42.24 39.2479 42.24 39.2479 42.2432 39.2479L43.056 37.1238C43.4144 36.1884 44.1792 35.5745 44.7712 35.4998C45.2256 35.4446 45.6192 35.6882 45.8528 36L47.1008 32.7456L48.2016 32.6092L45.3312 40.1184C45.136 40.625 45.2928 40.7907 45.536 40.7615C46.0224 40.6997 46.6976 39.8066 47.3696 38.7023L47.4336 38.6016C47.5904 38.6536 47.8016 38.8127 47.8976 38.9654L47.9136 38.9556ZM18.8672 43.4442C18.432 43.2169 18.1664 42.7914 18.0192 42.2815L17.7184 43.0707C17.6224 43.3403 17.584 43.5449 17.6032 43.7171C17.6384 44.0191 17.8592 44.1555 18.1024 44.1263C18.3776 44.0906 18.6944 43.8665 18.8672 43.4442ZM20.1056 39.8261C20.0672 39.5013 19.872 39.3259 19.6288 39.3584C19.0048 39.4363 18.4128 40.9303 18.5152 41.7878C18.5728 42.275 18.8 42.6225 19.1136 42.8174L19.9808 40.5731C20.096 40.2775 20.1312 40.0274 20.1056 39.8293V39.8261ZM35.6288 38.6081C36.0384 37.4518 34.8288 37.3089 34.3712 38.5074L33.1904 41.6254C32.9952 42.1321 33.1552 42.2977 33.3984 42.2685C33.8528 42.2133 34.4448 41.5864 34.9696 40.3587L35.6288 38.6081ZM45.3184 37.3999H45.3088C45.7184 36.2468 44.5088 36.1039 44.0512 37.2992L42.8704 40.4172C42.6752 40.9239 42.8352 41.0895 43.0784 41.0603C43.5424 41.0018 44.1536 40.3522 44.6752 39.0758L45.3216 37.3999H45.3184ZM34.7744 8.83111L36.48 4.36846L35.4752 4.49513L35.7216 3.87802L36.7168 3.7546L37.5168 1.65969L38.6176 1.52328L37.8176 3.61819L38.7264 3.50451L38.48 4.12162L37.5808 4.23205L35.7664 9.02598C35.5712 9.53266 35.7312 9.6983 35.9744 9.66907C36.4416 9.61061 37.0848 8.77914 37.7312 7.73006L40.1728 1.32515L41.2736 1.18874L39.9232 4.75171C40.3968 4.05991 40.8704 3.70588 41.3472 3.64742C41.9616 3.56947 42.496 4.17358 42.1312 5.14796L40.912 8.38939C40.7168 8.89607 40.8768 9.06171 41.12 9.03248C41.5904 8.97402 42.2336 8.13605 42.8832 7.08697C42.8832 7.07723 42.8896 7.07073 42.8928 7.06424L43.7856 4.75821C44.144 3.82281 44.7904 3.22519 45.68 3.11151C46.5792 2.99783 47.2512 3.7611 46.7936 4.94659L46.672 5.26813C46.0352 6.93107 44.72 7.24937 43.9744 7.01227L43.8944 7.23313C43.504 8.26922 43.9616 8.6817 44.64 8.59726C45.4112 8.49982 46.3296 7.57741 47.0016 6.46987L47.0656 6.36918C47.2224 6.42115 47.4336 6.5803 47.5296 6.73295C46.7584 8.00289 45.6512 9.22086 44.4032 9.37676C43.5392 9.48394 42.9312 9.03248 42.768 8.31794C42.1728 9.11693 41.5296 9.73403 40.8896 9.81523C40 9.92566 39.5744 9.14616 39.9328 8.19776L41.0336 5.30061C41.4016 4.35222 40.6144 4.14435 39.2032 6.68098L37.9168 10.0686L36.8064 10.2082L36.9952 9.7113C36.5888 10.1205 36.1696 10.4031 35.7504 10.4551C34.8608 10.5655 34.4352 9.786 34.7936 8.8376L34.7744 8.83111ZM44.208 6.37568C44.64 6.48611 45.3504 6.42115 45.7632 5.37207L45.8848 5.05052C46.3904 3.71887 45.2448 3.66366 44.7552 4.9336L44.2112 6.37568H44.208ZM46.4384 26.6947C44.464 29.3028 42.3328 31.2873 40.2176 31.5503C37.84 31.8459 36.4416 30.2609 36.5344 28.0101C34.96 30.1245 32.9024 32.4598 30.8512 32.7163C29.1808 32.9242 28.1088 31.8816 28.0256 30.0108C26.3136 32.044 24.5056 33.5088 22.7072 33.7329C20.5408 34.0025 19.1872 32.7131 19.0336 30.7773C15.568 34.1877 12.624 35.149 10.832 35.3731C8.2432 35.6947 6.1024 34.8405 4.8032 32.9664C3.3184 30.8228 3.1776 27.7048 4.4192 24.4082L8.6688 13.0632C10.3872 8.43811 13.3408 5.73908 17.2096 5.25514C19.0592 5.02454 20.6752 5.69036 21.6384 7.08048C22.7904 8.74017 22.8672 11.1404 21.8528 13.8394L21.3472 15.2068L17.9776 15.6258L18.3456 14.6287C19.1392 12.4688 19.2 10.7376 18.512 9.75352C18.1184 9.18838 17.5104 8.92854 16.8 9.01624C15.5808 9.16889 13.728 10.494 12.5152 13.729L8.3552 25.0058C7.1584 28.2764 7.6608 30.0401 8.2912 30.9397C9.0368 32.0051 10.3712 32.476 12.0448 32.2681C14.0448 32.018 17.0016 30.2901 20.1472 26.3537L28.7744 3.79033L32.5216 3.32263L22.8128 28.8805C22.144 30.6019 22.688 31.1736 23.5168 31.0729C25.1168 30.8748 27.3184 28.0231 29.5296 24.4406L34.3264 11.8971L38.0736 11.4294L32.448 26.2855C32.0832 27.2111 31.3344 28.8643 32.3232 29.1794C33.088 29.4424 35.0944 27.5944 37.5968 24.4049L42.7232 10.8513L46.4704 10.3836L40.3264 26.7012C39.6576 28.4226 40.2016 28.9942 41.0304 28.8935C42.624 28.6954 44.8128 25.8697 47.0144 22.3067C47.072 22.1411 47.1296 21.9787 47.1968 21.8098L55.3632 0.477445L59.184 0L55.52 9.61061C56.2112 8.96427 56.96 8.51281 57.8592 8.39913C59.9488 8.1393 61.4368 9.55215 61.6896 11.6406C61.8464 12.9397 61.568 14.5734 60.8512 16.5027C60.8512 16.5027 59.3632 21.0336 57.1808 25.756C55.6256 28.6272 53.3568 30.1115 51.264 30.3713C48.896 30.6669 46.8352 29.3807 46.4384 26.6914V26.6947ZM49.68 26.0516C49.8048 27.0747 50.5536 27.5424 51.3824 27.4385C52.32 27.3215 53.3952 26.5485 53.9904 25.113C55.264 21.8423 57.7792 15.327 57.7792 15.327C58.1696 14.3201 58.2848 13.4659 58.2048 12.7936C58.0704 11.6893 57.4144 11.0917 56.5856 11.1956C54.4704 11.4587 53.2864 15.314 51.0976 21.1537L50.0704 23.8398C49.744 24.7589 49.6064 25.4572 49.68 26.0484V26.0516Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-781080315_8527_clip0_1039_586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 45,
    fill: "white"
  }))))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-profile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.79,14.62c-4.2,0-7.79.64-7.79,3.18s3.57,3.2,7.79,3.2,7.79-.64,7.79-3.18-3.57-3.2-7.79-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.79,10.99c2.76,0,4.99-2.24,4.99-4.99S11.55,1,8.79,1,3.8,3.24,3.8,5.99c0,2.75,2.21,4.98,4.96,4.99h.04Z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "close-button",
    fill: "white",
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.52 8.46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sidebar-button",
    d: "m7.72,0c.18,0,.35.11.53.31.36.34.36.69,0,1.04l-2.94,2.9,2.89,2.84c.14.14.2.32.2.55,0,.13-.01.23-.04.32s-.08.16-.16.23c-.13.14-.31.2-.55.2s-.42-.07-.55-.2l-2.9-2.9-2.9,2.9c-.34.34-.69.34-1.04,0-.35-.35-.35-.69,0-1.04l2.89-2.9L.3,1.31c-.1-.07-.16-.15-.2-.22-.04-.08-.05-.17-.05-.28C.05.57.12.39.26.26.44.13.64.06.84.06s.38.07.5.2l2.9,2.89L7.16.26C7.36.08,7.54,0,7.72,0Z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 18,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2V6M8 2V6M3 10H21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 14,
    r: 1.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 1.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    r: 1.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 18,
    r: 1.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1.2,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.64dbac1e7794234958e1aff14e452ea9.svg";
export { ForwardRef as ReactComponent };